// extracted by mini-css-extract-plugin
module.exports = {"logo":"styles_logo__9DruR","desktop":"styles_desktop__f73Cu","mobile":"styles_mobile__aqv8w"};